import React, { useEffect, useState } from "react";
import Button from "./Button";
import { classNames } from "../../helpers/classNames";

const DragDropfile = ({
  label,
  isMultiple = false,
  labelClasses,
  value,
  handleFile = () => {},
}) => {
  const [files, setFile] = useState([]);
  const [message, setMessage] = useState();

  const handleFileChange = (e) => {
    setMessage("");
    const filesArray = Array.from(e.target.files);

    for (let i = 0; i < filesArray.length; i++) {
      const fileType = filesArray[i]["type"];
      const validImageTypes = ["application/pdf"];
      if (validImageTypes.includes(fileType)) {
        if (isMultiple) {
          setFile((prev) => [...prev, filesArray[i]]);
        } else {
          setFile([filesArray[i]]);
        }
      } else {
        setMessage("Only PDF files are accepted");
      }
    }
    e.target.value = null;
  };

  useEffect(() => {
    if (files?.length) {
      handleFile(files);
    }
  }, [files]);

  useEffect(() => {
    if (value) {
      setFile([value]);
    }
  }, [value]);

  const removeImage = (i) => {
    setFile(files.filter((x) => x.name !== i));
  };

  return (
    <div className="flex flex-col w-full gap-2">
      <div className="w-full relative space-y-1">
        {label && (
          <div
            className={classNames(
              "text-xs font-medium text-shades-07 mb-1 font-CanelaDeck",
              labelClasses
            )}
          >
            {label}
          </div>
        )}
        <div className="h-48 w-full relative border-2 items-center rounded-md cursor-pointer border-shades-05/50 border-dashed">
          <input
            type="file"
            onChange={handleFileChange}
            className="h-full w-full bg-green-200 opacity-0 z-10 absolute cursor-pointer"
            multiple="multiple"
            name="files[]"
          />
          <div className="h-full w-full absolute z-1 flex justify-center items-center top-0">
            <div className="flex flex-col space-y-1">
              <div className="text-chestnut-rose text-5xl text-center">
                <i className="fa-thin fa-cloud-arrow-up"></i>
              </div>
              <div className="text-sm font-bold text-center">
                Drag & Drop files here
              </div>
              <div className="text-xs text-shades-05 text-center">
                Supported formates: PDF
              </div>
            </div>
          </div>
        </div>
      </div>
      {message && (
        <div className="flex justify-center items-center text-xs mb-1 text-red-600">
          {message}
        </div>
      )}
      {files?.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {files.map((file, key) => (
            <div
              key={key}
              className="relative w-20 h-20 rounded-md border border-opplio-border flex group"
            >
              <div className="opacity-0 invisible transition-all duration-200 group-hover:opacity-100 group-hover:visible">
                <Button
                  buttonIcon={"fa-light fa-xmark"}
                  buttonIconPosition={"left"}
                  buttonClasses={
                    "!absolute !w-5 !h-5 !p-0 !justify-center -top-1 -right-1 !text-xs !bg-chestnut-rose !border-none"
                  }
                  buttonFunction={() => {
                    removeImage(file.name);
                  }}
                />
              </div>
              <div className="w-full h-full overflow-hidden rounded-md">
                <iframe
                  title="iframe"
                  alt="iframe"
                  width={200}
                  height={200}
                  className="h-full w-full object-cover"
                  src={
                    files[0] instanceof File
                      ? URL.createObjectURL(file)
                      : files[0]
                  }
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DragDropfile;
